import React from 'react';

const IndexItemBox = (props) => {
    const { imgName, content } = props;
    return(
        <div className="box-wrapper">
            <img src={require(`../assets/images/${imgName}`)}/>
            <div dangerouslySetInnerHTML={{__html: content}}></div>
        </div>
    )
}

export default IndexItemBox;